import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconLinkedinComponent } from "./med-icon-linkedin.component";

@NgModule({
  declarations: [
    MedIconLinkedinComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconLinkedinComponent,
  ],
})
export class MedIconLinkedinModule { }
